import styled, { css } from 'styled-components';

const fontFamily = css`
  font-family: ${props => props.theme.v2.fontFamily.default};
`;

export const H1Css = css`
  ${fontFamily}
  font-style: normal;
  font-weight: bold;
  font-size: 42px;
  line-height: 55px;
`;

export const H2Css = css`
  ${fontFamily}
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 51px;
`;

export const H3Css = css`
  ${fontFamily}
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 31px;
`;

export const H4Css = css`
  ${fontFamily}
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
`;

export const H5Css = css`
  ${fontFamily}
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
`;

export const H6Css = css`
  ${fontFamily}
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 26px;
`;

export const H7Css = css`
  ${fontFamily}
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 26px;
`;

// Declaring the styled component
const Heading = styled.span`
  ${props => props.size === 100 && H1Css}
  ${props => props.size === 200 && H2Css}
  ${props => props.size === 300 && H3Css}
  ${props => props.size === 400 && H4Css}
  ${props => props.size === 500 && H5Css}
  ${props => props.size === 600 && H6Css}
  ${props => props.size === 700 && H7Css}

`;

export default Heading;
